import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d118c33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-rounded-md tw-border tw-border-solid tw-border-[#EFF0F1] tex tw-bg-[#FFF]" }
const _hoisted_2 = { class: "tw-flex tw-w-full tw-h-16 tw-items-center tw-px-[25px]" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[15px] tw-font-semibold" }

import ScanningTypesCollapseItem from "@/components/scanning/scanningTypes/scanningTypesCollapseItem.vue";
import ScanningTypeResults from "@/components/scanning/scanningTypes/scanningTypeResults.vue";
import { getComponentUiText } from "@/utils/utilities";
import { computed, onMounted, ref, watch } from "vue";
import store from "@/store";
import { SCAN_ITEM_STATUS_ID, TYPE_SCHEDULE } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isExpand: { type: Boolean },
    runId: {},
    scanTargetType: {},
    rootId: {},
    hoverBgColor: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(true);

const scanningData = computed<Record<string, any>[]>(() => {
  const scanReportRun = store.getters["Scanning/getScanReportRun"];
  return scanReportRun[props.scanTargetType][props.runId]?.data || [];
});

const callData = async () => {
  if (props.isExpand && !scanningData.value?.length) {
    isLoading.value = true;
    await store.dispatch("Scanning/fetchScanReportRun", {
      runId: props.runId,
      scanTargetType: props.scanTargetType,
    });
  }
  isLoading.value = false;
};

onMounted(async () => {
  await callData();
});

watch(
  () => [props.isExpand, props.runId],
  async () => {
    await callData();
  },
);

const getScanItem = (scanItems) => {
  const severity = {
    critical: 0,
    high: 0,
    med: 0,
    low: 0,
  };

  if (scanItems?.length > 0) {
    scanItems.forEach((item) => {
      if (
        item.scanItemStatusId !== SCAN_ITEM_STATUS_ID.OK &&
        item.scanItemStatusId !== SCAN_ITEM_STATUS_ID.NOT_AVAILABLE &&
        item.scanItemStatusId !== SCAN_ITEM_STATUS_ID.NOT_APPLICABLE
      ) {
        severity[item.scanItemSeverityId] += 1;
      }
    });
  }
  return {
    critical: severity.critical ? severity.critical : null,
    high: severity.high ? severity.high : null,
    medium: severity.med ? severity.med : null,
    low: severity.low ? severity.low : null,
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-types-title-1")), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scanningData.value, (item) => {
      return (_openBlock(), _createBlock(ScanningTypesCollapseItem, {
        key: item.scanDisplayTypeId,
        title: item.scanDisplayType,
        "scan-items": getScanItem(item.scanItems),
        "class-name": _ctx.hoverBgColor
      }, {
        default: _withCtx(() => [
          _createVNode(ScanningTypeResults, {
            "is-loading": isLoading.value,
            data: item.scanItems,
            "type-id": item.scanDisplayTypeId,
            "scan-target-type": _ctx.scanTargetType,
            "root-id": _ctx.rootId
          }, null, 8, ["is-loading", "data", "type-id", "scan-target-type", "root-id"])
        ]),
        _: 2
      }, 1032, ["title", "scan-items", "class-name"]))
    }), 128))
  ]))
}
}

})